// Maestro: per-inbox brand signature.
// The brand block is now persisted on `inboxes.brand_signature` (admin-edited
// per inbox) and is appended SERVER-SIDE at email-envelope build time. The
// composer carries only the agent's personal signature; the brand sig is
// stitched in at send. See app/builders/messages/email_envelope.rb#append_brand_signature_for_send.

/**
 * Distinctive single-line markers that uniquely identify the historical brand
 * signature blocks. TEMP: kept as a tail-anchor dedup defence in
 * editorHelper.js#appendSignature so the legacy-draft cohort (rows persisted
 * with body=`personal\n\n--\n\nbrand` before the migration) does not produce
 * duplicate brand blocks when re-loaded into the composer and re-sent.
 * Remove after the cohort has drained (~30 days post-deploy) along with the
 * tail-anchor block in editorHelper.js and lib/maestro_brand_signatures.rb.
 */
export const BRAND_SIGNATURE_ANCHORS = [
  '**T**  +1 (281) 201-5552', // ShinySmile Veneers
  '**T**  +1 (850) 364-4800', // TruSmile Veneers
];

/**
 * Read the brand signature configured for the given inbox. Returns empty
 * string when the inbox has no brand sig (or no inbox is supplied). Used by
 * the composer's "Sending from <inbox>" indicator to know when to display
 * the auto-append hint.
 */
export function getInboxSignature(inbox) {
  if (!inbox) return '';
  return inbox.brand_signature || inbox.brandSignature || '';
}

/**
 * Get the signature for the editor body. Now returns the user's personal
 * signature unchanged — the brand block is no longer composed client-side.
 * Kept as a thin pass-through so call sites do not need to know which signal
 * is appended where.
 */
export function getSignatureForInbox(_inbox, userSignature = '') {
  return userSignature;
}

export default {};
